
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import Beleg from '@/types/Beleg';
    import _ from 'lodash';
    import Belegposition from '@/types/Belegposition';
    import { confirmSwal } from '@/helper/swals';
    import { SweetAlertResult } from 'sweetalert2';
    import Impfstelle from '@/types/Impfstelle';
    import { KassaabschlussPayload } from '@/store/kassafuehrung';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';

    @Component({
        computed: {
            ...mapState('authentication', ['impfstelle_id']),
            ...mapState('kassafuehrung', ['offeneBelege', 'offeneBelegeLeistungen', 'loaders']),
            ...mapGetters('authentication', ['impfstelleDetail']),
            ...mapGetters('authentication', ['getSystemEinstellung']),
        },
        methods: {
            ...mapActions('kassafuehrung', [
                'loadOffeneBelege',
                'kassaabschluss',
                'printKassaliste',
                'exportKassaliste',
            ]),
            ...mapMutations('kassafuehrung', ['setDialogKassaabschluss']),
        },
    })
    export default class KassaabschlussDialog extends Vue {
        @Prop() visible!: boolean;

        public loadOffeneBelege!: () => void;
        public offeneBelege!: Beleg[];
        public offeneBelegeLeistungen!: Belegposition[];
        public impfstelleDetail!: Impfstelle;
        public impfstelle_id!: number;
        public kassaabschluss!: (payload: KassaabschlussPayload) => void;
        public deleteWarteliste: string | null = null;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public barsumme = 0;

        protected belegeSum = (sum: number, beleg: Beleg): number => {
            return sum += (!beleg.isStorniert ? beleg.gesamtbetrag ?? 0 : 0);
        };

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                if (this.getSystemEinstellung('warteliste_remove_kassaabschluss').isEnabled()) {
                    this.deleteWarteliste = 'j';
                } else {
                    this.deleteWarteliste = 'n';
                }
                this.loadOffeneBelege();
            }
        }

        public get gesamt(): number {
            return this.offeneBelege.reduce(this.belegeSum, 0) ?? 0;
        }

        public get verwaltungsabgaben(): number {
            return this.offeneBelegeLeistungen.reduce((sum: number, leistung: Belegposition) => {
                return sum += (!leistung.isStorniert ? leistung.betrag_brutto ?? 0 : 0);
            }, 0) ?? 0;
        }

        public summe(belege: Beleg[]): number {
            if (belege[0].zahlungsart === 'BAR') {
                this.barsumme = belege.reduce(this.belegeSum, 0);
            }
            return belege.reduce(this.belegeSum, 0);
        }

        public get saldo(): number {
            return this.offeneBelege.reduce(this.belegeSum, 0);
        }

        public get groupedBelege(): { [zahlungsart: string]: Beleg[] } {
            return _.groupBy(this.offeneBelege, 'zahlungsart');
        }

        public onClickKassaabschluss(): void {
            confirmSwal('Kassaabschluss', 'Wollen Sie wirklich die Kassa abschließen?', 'Abschließen', ' Abbrechen')
                .then(({ isConfirmed }: SweetAlertResult) => {
                    if (isConfirmed) {
                        const saldo = this.saldo;
                        const anfangssaldo = this.impfstelleDetail.anfangssaldo ?? 0;

                        this.kassaabschluss({
                            saldo,
                            anfangssaldo,
                            gesamtbetrag: (anfangssaldo + saldo).toFixed(2),
                            offeneBelege: this.offeneBelege,
                            impfstelle_id: this.impfstelle_id,
                            deletewarteliste: this.deleteWarteliste
                        });
                    }
                });
        }
    }
